import {
    GET_INVOICE_CLIENT_LOADING,
    GET_INVOICE_CLIENT_SUCCESS,
    GET_INVOICE_CLIENT_REJECT,
} from "../../actions/invoiceClient/getAll";
import {
    GET_INVOICE_CLIENT_ID_LOADING,
    GET_INVOICE_CLIENT_ID_SUCCESS,
    GET_INVOICE_CLIENT_ID_REJECT,
} from "../../actions/invoiceClient/getId";
import {
    POST_INVOICE_CLIENT_RESET,
    POST_INVOICE_CLIENT_LOADING,
    POST_INVOICE_CLIENT_SUCCESS,
    POST_INVOICE_CLIENT_REJECT,
} from "../../actions/invoiceClient/post";
import {
    PUT_INVOICE_CLIENT_RESET,
    PUT_INVOICE_CLIENT_LOADING,
    PUT_INVOICE_CLIENT_SUCCESS,
    PUT_INVOICE_CLIENT_REJECT,
} from "../../actions/invoiceClient/put";
import {
    DELETE_INVOICE_CLIENT_RESET,
    DELETE_INVOICE_CLIENT_LOADING,
    DELETE_INVOICE_CLIENT_SUCCESS,
    DELETE_INVOICE_CLIENT_REJECT,
} from "../../actions/invoiceClient/delete";
import {
    CANCEL_INVOICE_CLIENT_RESET,
    CANCEL_INVOICE_CLIENT_LOADING,
    CANCEL_INVOICE_CLIENT_SUCCESS,
    CANCEL_INVOICE_CLIENT_REJECT,
} from "../../actions/invoiceClient/cancel";
import {
    REPROCESS_ODOO_INVOICE_CLIENT_RESET,
    REPROCESS_ODOO_INVOICE_CLIENT_LOADING,
    REPROCESS_ODOO_INVOICE_CLIENT_SUCCESS,
    REPROCESS_ODOO_INVOICE_CLIENT_REJECT,
} from "../../actions/invoiceClient/reprocessOdoo";
import {
    PROCESS_ODOO_INVOICE_CLIENT_RESET,
    PROCESS_ODOO_INVOICE_CLIENT_LOADING,
    PROCESS_ODOO_INVOICE_CLIENT_SUCCESS,
    PROCESS_ODOO_INVOICE_CLIENT_REJECT,
} from "../../actions/invoiceClient/processOdoo";
import {
    POST_INVOICE_CLIENT_ITEM_RESET,
    POST_INVOICE_CLIENT_ITEM_LOADING,
    POST_INVOICE_CLIENT_ITEM_SUCCESS,
    POST_INVOICE_CLIENT_ITEM_REJECT,
} from "../../actions/invoiceClient/postItem";
import {
    PUT_INVOICE_CLIENT_ITEM_RESET,
    PUT_INVOICE_CLIENT_ITEM_LOADING,
    PUT_INVOICE_CLIENT_ITEM_SUCCESS,
    PUT_INVOICE_CLIENT_ITEM_REJECT,
} from "../../actions/invoiceClient/putItem";
import {
    DELETE_INVOICE_CLIENT_ITEM_RESET,
    DELETE_INVOICE_CLIENT_ITEM_LOADING,
    DELETE_INVOICE_CLIENT_ITEM_SUCCESS,
    DELETE_INVOICE_CLIENT_ITEM_REJECT,
} from "../../actions/invoiceClient/deleteItem";
import {
    GET_INVOICE_CLIENT_LIST_DTE_LOADING,
    GET_INVOICE_CLIENT_LIST_DTE_SUCCESS,
    GET_INVOICE_CLIENT_LIST_DTE_REJECT,
    GET_INVOICE_CLIENT_LIST_DTE_RESET,
} from "../../actions/invoiceClient/getListDTE";

const subState = { isLoading: false, isSuccess: false, isReject: false, error: {}, data: {} };

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: { data: [], totalRecord: 0, currentPage: 1 },
    detail:        { ...subState, data: {} },
    post:          { ...subState },
    put:           { ...subState },
    delete:        { ...subState },
    cancel:        { ...subState },
    reprocessOdoo: { ...subState },
    processOdoo:   { ...subState },
    postItem:      { ...subState },
    putItem:       { ...subState },
    deleteItem:    { ...subState },
    listDTE:       { ...subState, data: [] },
};

const invoiceClientReducer = (state = stateInit, { type, payload }) => {
    switch (type) {
        // ── getAll ──────────────────────────────────────────────────────────
        case GET_INVOICE_CLIENT_LOADING:
            return { ...state, isLoading: true, isSuccess: false, isReject: false, error: {} };
        case GET_INVOICE_CLIENT_SUCCESS:
            return { ...state, isLoading: false, isSuccess: true, data: payload?.data ?? state.data };
        case GET_INVOICE_CLIENT_REJECT:
            return { ...state, isLoading: false, isReject: true, error: payload };

        // ── getById ─────────────────────────────────────────────────────────
        case GET_INVOICE_CLIENT_ID_LOADING:
            return { ...state, detail: { ...state.detail, isLoading: true, isSuccess: false, isReject: false, error: {} } };
        case GET_INVOICE_CLIENT_ID_SUCCESS:
            return { ...state, detail: { ...state.detail, isLoading: false, isSuccess: true, data: payload?.data ?? {} } };
        case GET_INVOICE_CLIENT_ID_REJECT:
            return { ...state, detail: { ...state.detail, isLoading: false, isReject: true, error: payload } };

        // ── post ────────────────────────────────────────────────────────────
        case POST_INVOICE_CLIENT_RESET:
            return { ...state, post: { ...subState } };
        case POST_INVOICE_CLIENT_LOADING:
            return { ...state, post: { ...state.post, isLoading: true, isSuccess: false, isReject: false, error: {} } };
        case POST_INVOICE_CLIENT_SUCCESS:
            return { ...state, post: { ...state.post, isLoading: false, isSuccess: true, ...payload, data: payload?.data ?? {} } };
        case POST_INVOICE_CLIENT_REJECT:
            return { ...state, post: { ...state.post, isLoading: false, isReject: true, error: payload } };

        // ── put ─────────────────────────────────────────────────────────────
        case PUT_INVOICE_CLIENT_RESET:
            return { ...state, put: { ...subState } };
        case PUT_INVOICE_CLIENT_LOADING:
            return { ...state, put: { ...state.put, isLoading: true, isSuccess: false, isReject: false, error: {} } };
        case PUT_INVOICE_CLIENT_SUCCESS:
            return { ...state, put: { ...state.put, isLoading: false, isSuccess: true, data: payload?.data ?? {} } };
        case PUT_INVOICE_CLIENT_REJECT:
            return { ...state, put: { ...state.put, isLoading: false, isReject: true, error: payload } };

        // ── delete ──────────────────────────────────────────────────────────
        case DELETE_INVOICE_CLIENT_RESET:
            return { ...state, delete: { ...subState } };
        case DELETE_INVOICE_CLIENT_LOADING:
            return { ...state, delete: { ...state.delete, isLoading: true, isSuccess: false, isReject: false, error: {} } };
        case DELETE_INVOICE_CLIENT_SUCCESS:
            return { ...state, delete: { ...state.delete, isLoading: false, isSuccess: true, data: payload?.data ?? {} } };
        case DELETE_INVOICE_CLIENT_REJECT:
            return { ...state, delete: { ...state.delete, isLoading: false, isReject: true, error: payload } };

        // ── cancel ──────────────────────────────────────────────────────────
        case CANCEL_INVOICE_CLIENT_RESET:
            return { ...state, cancel: { ...subState } };
        case CANCEL_INVOICE_CLIENT_LOADING:
            return { ...state, cancel: { ...state.cancel, isLoading: true, isSuccess: false, isReject: false, error: {} } };
        case CANCEL_INVOICE_CLIENT_SUCCESS:
            return { ...state, cancel: { ...state.cancel, isLoading: false, isSuccess: true, data: payload?.data ?? {} } };
        case CANCEL_INVOICE_CLIENT_REJECT:
            return { ...state, cancel: { ...state.cancel, isLoading: false, isReject: true, error: payload } };

        // ── reprocessOdoo ───────────────────────────────────────────────────
        case REPROCESS_ODOO_INVOICE_CLIENT_RESET:
            return { ...state, reprocessOdoo: { ...subState } };
        case REPROCESS_ODOO_INVOICE_CLIENT_LOADING:
            return { ...state, reprocessOdoo: { ...state.reprocessOdoo, isLoading: true, isSuccess: false, isReject: false, error: {} } };
        case REPROCESS_ODOO_INVOICE_CLIENT_SUCCESS:
            return { ...state, reprocessOdoo: { ...state.reprocessOdoo, isLoading: false, isSuccess: true, data: payload?.data ?? {} } };
        case REPROCESS_ODOO_INVOICE_CLIENT_REJECT:
            return { ...state, reprocessOdoo: { ...state.reprocessOdoo, isLoading: false, isReject: true, error: payload } };

        // ── processOdoo ─────────────────────────────────────────────────────
        case PROCESS_ODOO_INVOICE_CLIENT_RESET:
            return { ...state, processOdoo: { ...subState } };
        case PROCESS_ODOO_INVOICE_CLIENT_LOADING:
            return { ...state, processOdoo: { ...state.processOdoo, isLoading: true, isSuccess: false, isReject: false, error: {} } };
        case PROCESS_ODOO_INVOICE_CLIENT_SUCCESS:
            return { ...state, processOdoo: { ...state.processOdoo, isLoading: false, isSuccess: true, data: payload?.data ?? {} } };
        case PROCESS_ODOO_INVOICE_CLIENT_REJECT:
            return { ...state, processOdoo: { ...state.processOdoo, isLoading: false, isReject: true, error: payload } };

        // ── postItem ────────────────────────────────────────────────────────
        case POST_INVOICE_CLIENT_ITEM_RESET:
            return { ...state, postItem: { ...subState } };
        case POST_INVOICE_CLIENT_ITEM_LOADING:
            return { ...state, postItem: { ...state.postItem, isLoading: true, isSuccess: false, isReject: false, error: {} } };
        case POST_INVOICE_CLIENT_ITEM_SUCCESS:
            return { ...state, postItem: { ...state.postItem, isLoading: false, isSuccess: true, data: payload?.data ?? {} } };
        case POST_INVOICE_CLIENT_ITEM_REJECT:
            return { ...state, postItem: { ...state.postItem, isLoading: false, isReject: true, error: payload } };

        // ── putItem ─────────────────────────────────────────────────────────
        case PUT_INVOICE_CLIENT_ITEM_RESET:
            return { ...state, putItem: { ...subState } };
        case PUT_INVOICE_CLIENT_ITEM_LOADING:
            return { ...state, putItem: { ...state.putItem, isLoading: true, isSuccess: false, isReject: false, error: {} } };
        case PUT_INVOICE_CLIENT_ITEM_SUCCESS:
            return { ...state, putItem: { ...state.putItem, isLoading: false, isSuccess: true, data: payload?.data ?? {} } };
        case PUT_INVOICE_CLIENT_ITEM_REJECT:
            return { ...state, putItem: { ...state.putItem, isLoading: false, isReject: true, error: payload } };

        // ── deleteItem ──────────────────────────────────────────────────────
        case DELETE_INVOICE_CLIENT_ITEM_RESET:
            return { ...state, deleteItem: { ...subState } };
        case DELETE_INVOICE_CLIENT_ITEM_LOADING:
            return { ...state, deleteItem: { ...state.deleteItem, isLoading: true, isSuccess: false, isReject: false, error: {} } };
        case DELETE_INVOICE_CLIENT_ITEM_SUCCESS:
            return { ...state, deleteItem: { ...state.deleteItem, isLoading: false, isSuccess: true, data: payload?.data ?? {} } };
        case DELETE_INVOICE_CLIENT_ITEM_REJECT:
            return { ...state, deleteItem: { ...state.deleteItem, isLoading: false, isReject: true, error: payload } };

        // ── listDTE ─────────────────────────────────────────────────────────
        case GET_INVOICE_CLIENT_LIST_DTE_RESET:
            return { ...state, listDTE: { ...subState, data: [] } };
        case GET_INVOICE_CLIENT_LIST_DTE_LOADING:
            return { ...state, listDTE: { ...state.listDTE, isLoading: true, isSuccess: false, isReject: false, error: {} } };
        case GET_INVOICE_CLIENT_LIST_DTE_SUCCESS:
            return { ...state, listDTE: { ...state.listDTE, isLoading: false, isSuccess: true, data: payload?.data ?? [] } };
        case GET_INVOICE_CLIENT_LIST_DTE_REJECT:
            return { ...state, listDTE: { ...state.listDTE, isLoading: false, isReject: true, error: payload } };

        default:
            return state;
    }
};

export default invoiceClientReducer;
